import getDynamicConfig from '../utility/get-dynamic-config';
import getStaticConfig from '../utility/get-static-config';
const config = (() => {
    const RUNTIME_CONFIG = {
        NODE_ENV: process.env.NODE_ENV,
        version: process.env.VERSION,
        commitSha: process.env.COMMIT_SHA,
    };
    if (process.env.USE_DYNAMIC_CONFIGURATION) {
        const DYNAMIC_CONFIG = getDynamicConfig();
        return {
            ...DYNAMIC_CONFIG,
            ...RUNTIME_CONFIG,
        };
    }
    const env = process.env.BUILD_ENV;
    const STATIC_CONFIG = getStaticConfig(env);
    return {
        ...STATIC_CONFIG,
        ...RUNTIME_CONFIG,
    };
})();
export default config;
